<template>
  <PageTemplate>
    <h1>Edit Registration</h1>
    <div>
      <v-card
        v-if="form.roles"
        :title="form.first_name + ' ' + form.last_name + ' \'s Personal Details'"
      >
        <template>
          <v-label text="Select User Type*" />
          <fieldset class="fieldset">
            <v-checkbox
              v-for="role in defaultRoles"
              :id="role.id"
              :key="role.id"
              :value="role.value"
              :checked="containsObject(role,form.roles)"
              @check="checkInObj(role,form.roles)"
            >
              {{ role.value }}
            </v-checkbox>
            <v-input-help
              v-if="roleCheckError"
              class="fieldset__text"
              :text="roleCheckError"
            />
          </fieldset>
          <div class="row">
            <v-fieldset
              id="first_name"
              v-model="form.first_name"
              class="col-md-6"
              text="First Name*"
              placeholder="First Name"
              :is-required="true"
              :help-text="validationErrors.first_name"
            />
            <v-fieldset
              id="last_name"
              v-model="form.last_name"
              class="col-md-6"
              text="Last Name*"
              placeholder="Last Name"
              :is-required="true"
              :help-text="validationErrors.last_name"
            />
            <v-fieldset
              id="title"
              v-model="form.title"
              class="col-md-6"
              text="Position Title*"
              placeholder="Title"
              :is-required="true"
              :help-text="validationErrors.title"
            />
            <v-fieldset
              id="mobile_number"
              v-model="form.mobile_number"
              class="col-md-6"
              text="Phone*"
              pattern="[0-9]+"
              placeholder="Phone Number"
              :is-required="true"
              :help-text="validationErrors.mobile_number"
            />
            <v-fieldset
              id="email"
              v-model="form.email"
              class="col-md-6"
              text="Email*"
              type="email"
              placeholder="Email"
              :is-required="true"
              :help-text="validationErrors.email"
            />
            <v-fieldset
              id="address"
              v-model="form.address"
              class="col-md-6"
              text="Address*"
              placeholder="Address"
              :is-required="true"
              :help-text="validationErrors.address"
            />
            <v-fieldset
              id="country"
              v-model="form.country"
              class="col-md-6"
              text="Country"
              placeholder="Country"
              :help-text="validationErrors.country"
            />
            <v-fieldset
              v-if="states.length > 0"
              id="state"
              v-model="state"
              class="col-md-6"
              text="State"
              placeholder=" "
              :select-options="states"
              :help-text="validationErrors.state"
            />
            <v-fieldset
              id="suburb"
              v-model="form.suburb"
              class="col-md-6"
              text="Suburb"
              placeholder="Suburb"
              :help-text="validationErrors.suburb"
            />
            <v-fieldset
              id="postcode"
              v-model="form.postcode"
              class="col-md-6"
              pattern="^[0-9]+$"
              text="Post Code"
              placeholder="Post Code"
              :help-text="validationErrors.postcode"
            />
            <v-fieldset
              v-if="valueExistInObjArray(constants.NATA_ROLE_TA,form.roles)"
              id="userId"
              v-model="form.user_id"
              class="col-md-6"
              placeholder="User ID"
              text="User ID"
              :is-required="true"
              :help-text="validationErrors.userId"
            />
          </div>
        </template>
        <template v-if="valueExistInObjArray(constants.NATA_ROLE_AR,form.roles)">
          <div
            v-for="(item,index) in form.facilities"
            :key="index"
          >
            <v-headline
              :text="'Facility '+ setFacilitySeq(index)"
              :level="4"
            >
              <v-button
                v-if="index > 0"
                color="transparent"
                @click="delFacility(index)"
              >
                <v-icon type="times" />
              </v-button>
            </v-headline>
            <div class="row">
              <v-fieldset
                :id="'facility_number ' + index"
                v-model="item.facility_number"
                class="col-md-6"
                text="Facility Accreditation Number*"
                placeholder="Please input facility number"
                :is-required="true"
                :readonly="checkEditable(index,'facility_name')"
                @keyup="getFacility($event, index)"
              />
              <v-fieldset
                :id="'facility ' + index"
                v-model="item.facility_name"
                class="col-md-6"
                text="Facility Name*"
                placeholder="Facility name"
                :is-required="true"
                :readonly="true"
              />
              <div
                v-if="item.allSites && item.allSites.length>0"
                class="col-md-6"
              >
                <v-checkbox
                  v-for="site in item.allSites"
                  :id="site.site_number"
                  :key="site.site_number"
                  :value="site.site_number"
                  :checked="containsObject(site,item.sites,true)"
                  @check="checkInObj(site,item.sites,true)"
                >
                  {{ site.site_number }} - {{ site.name }}
                </v-checkbox>
              </div>
            </div>
          </div>
          <v-button
            color="secondary"
            @click="addFacility()"
          >
            <v-icon type="plus" />
            Add Facility
          </v-button>
        </template>
        <template v-if="valueExistInObjArray(constants.NATA_ROLE_CM,form.roles)">
          <div>
            <strong>Select at least One or More Committees if Applicable from the List of Committees</strong>
            <fieldset class="fieldset">
              <v-checkbox
                v-for="committee in committees"
                :id="committee.id"
                :key="committee.value"
                :value="committee.value"
                :checked="containsObject(committee,form.committees,true)"
                @check="checkInObj(committee,form.committees)"
              >
                {{ committee.value }}
              </v-checkbox>
            </fieldset>
          </div>
        </template>
        <template>
          <div v-if="generalPublicationCat.length > 0">
            <strong>Subscriptions</strong>
            <v-label text="General Publication" />
            <v-checkbox-list
              id="general"
              v-model="selectedGeneralPublication"
              :groups="generalPublicationCat"
              :selected-group="selectedGeneralPublication"
              @change="userSubscriptionChange"
            />
          </div>
        </template>
        <template>
          <v-button-group is-left>
            <v-button
              size="lg"
              has-min-width
              @click="save"
            >
              Save
            </v-button>
            <v-button
              size="lg"
              color="danger"
              has-min-width
              @click="cancel"
            >
              Cancel
            </v-button>
          </v-button-group>
        </template>
      </v-card>
      <v-button
        color="transparent"
        @click="$router.push('/admin/outstanding-activities')"
      >
        Cancel
      </v-button>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Card from "@/molecules/Card";
  import Icon from "@/atoms/Icon";
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Headline from "@/atoms/Headline";
  import InputHelp from "@/atoms/InputHelp";
  import Fieldset from "@/molecules/Fieldset";
  import Checkbox from "@/atoms/Checkbox";
  import Label from "@/atoms/Label";
  import CheckboxList from "@/molecules/CheckboxList";
  import {buildBreadCrumb,buildDefinitionList, zeroPad} from "@/common/tableFunctions"
  import {mapState} from "vuex";
  import {
    GET_ALL_USERS,
    GET_USER_INFO,
    GET_FACILITY_INFO,
    GET_USER_REQUEST,
    GET_COMMITTEES,
    UPDATE_REGISTRATION_REQUEST, GET_ALL_PUBLICATION_CATEGORIES
  } from "../../store/actions.type";
  import constants from "@/common/constants";
  import routes from "@/common/routes";

  export default {
    name: "EditPersonalDetails",
    components: {
      "v-card": Card,
      "v-headline": Headline,
      "v-icon": Icon,
      "v-input-help": InputHelp,
      "v-button": Button,
      "v-button-group": ButtonGroup,
      "v-checkbox": Checkbox,
      "v-label":Label,
      "v-fieldset":Fieldset,
      "v-checkbox-list": CheckboxList,
      PageTemplate
    },
    data: () => ({
      updatedSubscription: null,
      defaultRoles: [
        {
          "id": constants.NATA_ROLE_AR,
          "value": "Authorised Representative",
        },
        {
          "id": constants.NATA_ROLE_CM,
          "value": "Committee Member",
        },
        {
          "id": constants.NATA_ROLE_TA,
          "value": "Technical Assessor",
        }
      ],
      roleCheckError: '',
      states:[],
      committees: [],
      publication_categories:[],
      validationErrors:{},
      personalDetailIsReady: false,
      facilityDetailIsReady: false,
      committeeIsReady: false,
      isConfirm: false,
    }),
    watch:{
      'form.country':{
        handler:function(val, oldVal){
          // if country != 'au', force to set 'OTHER'
          if(val !== undefined && val !== null && val.length > 0){
            if(val.toString().toLowerCase() !== 'australia'){
              this.form.state = 'Other';
              document.getElementById('state').disabled = true;
            }else{
              this.resetStates();
              document.getElementById('state').disabled = false;
            }
          }else{
            this.resetStates();
            document.getElementById('state').disabled = false;
          }
        }
      },
      form:{
        deep:true,
        handler:function(val,oldVal)
        {
          for(let key in val){
            const checkField = document.getElementById(key);
            if(checkField != null && checkField.value.length > 0){
              const isValid = checkField.checkValidity();
              if(!isValid){
                this.validationErrors[key] = 'Please input valid detail for  '+ checkField.placeholder;
              }else{
                delete this.validationErrors[key];
              }
            }
          }
          this.personalDetailIsReady = (Object.keys(this.validationErrors).length === 0 && this.form.roles.length > 0);
        }
      }
    },
    computed: {
      ...mapState({
        users: state => state.userRequest.users,
        registrations: state => state.userRequest.registrations,
        form: state => state.userRequest.currentRegistrations,
      }),
      selectedGeneralPublication:{
        get(){
          let results = [];
          for (let sub of this.form.subscriptions) {
            sub.selected = 1;
            results.push(sub);
          }
          //results = this.formatSubscriptionListForCheckBox(results);
          return results;
        },
        set(val){
          if(this.form.subscriptions)
            this.form.subscriptions[0].selected = val;
        }
      },
      generalPublicationCat(){
        let general = this.publication_categories;
        let data = this.formatCheckboxList(general);
        return data
      },
      state: {
        get: function () {
          return this.form.state;
        },
        set: function (newValue) {
          this.form.state = newValue
        }
      },
    },
    created() {
      this.constants = constants;
    },
    mounted() {
      this.updateBreadCrumb();
      this.resetStates();
      this.updateCurrentReg(this.$route.params.id);
      this.getCommittee();
      this.getPublicationCat();
    },
    methods: {
      save(){
        if(this.valueExistInObjArray(constants.NATA_ROLE_AR,this.form.roles) && this.valueExistInObjArray(constants.NATA_ROLE_CM,this.form.roles))
        {
          this.validateFacility();
          this.validateCommittee();
          if(this.personalDetailIsReady && this.facilityDetailIsReady && this.committeeIsReady){
            this.isConfirm = true;
          }else{
            this.isConfirm = false;
          }
        }
        else if(this.valueExistInObjArray(constants.NATA_ROLE_AR,this.form.roles)){
           this.validateFacility();
            if(this.personalDetailIsReady && this.facilityDetailIsReady){
              this.isConfirm = true;
            }else{
              this.isConfirm = false;
            }
        }
        else if(this.valueExistInObjArray(constants.NATA_ROLE_CM,this.form.roles)){
          this.validateCommittee();
          if(this.personalDetailIsReady && this.committeeIsReady){
            this.isConfirm = true;
          }else{
            this.isConfirm = false;
          }
        }else {
          if(this.personalDetailIsReady){
            this.isConfirm = true;
          }else{
            this.isConfirm = false;
          }
        }
        if(this.updatedSubscription) {
          this.form.subscriptions = this.updatedSubscription;
        }
        if(this.isConfirm){
          this.$store.dispatch(UPDATE_REGISTRATION_REQUEST,[this.$route.params.id,this.form])
            .then(response => {
              this.$router.push(routes.ADMIN.PENDING_REGISTRATION+this.$route.params.id);
            })
            .catch(error => {
              this.$notify({
                title: 'Error',
                text: error.data.message,
                type: 'error'
              });
            })
        }
      },
      validateFacility(){
        this.facilityDetailIsReady = false;
        if(!this.facilityDetailIsReady){
          for(var i =0; i < this.form.facilities.length; i++)
          {
            if(this.form.facilities[i].facility_name.length > 0){
              document.getElementById('facility_number '+i).readOnly = true;
            }
            if(this.form.facilities[i].facility_number.length === 0){
              this.facilityError = 'At lease one Facility should be selected or one of Facility Number is missing!';
              this.$notify({
                title: 'Error',
                text: this.facilityError,
                type: 'error'
              });
              break;
            }else if(this.form.facilities[i].facility_name.length === 0){
              this.facilityError = 'Facility Name for Facility ' + parseInt(i+1) + ' is missing!';
              this.$notify({
                title: 'Error',
                text: this.facilityError,
                type: 'error'
              });
              break;
            }else if(this.form.facilities[i].allSites.length > 0 && this.form.facilities[i].sites.length === 0){
              this.facilityError = 'At least 1 site should be choose for Facility '+this.form.facilities[i].facility_number+' - '+this.form.facilities[i].facility_name;
              this.$notify({
                title: 'Error',
                text: this.facilityError,
                type: 'error'
              });
              break;
            }else {
              this.facilityError = '';
            }
          }
          this.facilityDetailIsReady = (this.form.facilities.length > 0 && this.facilityError.length === 0);
        }
      },
      validateCommittee(){
        if(this.form.committees.length > 0){
          this.committeeIsReady = true;
        }else{
          this.committeeIsReady = false;
          this.$notify({
            title: 'Error',
            text: 'At lease 1 committee should be selected!',
            type: 'error'
          });
        }
      },
      cancel(){
        this.$router.push(routes.ADMIN.PENDING_REGISTRATION+this.$route.params.id);
      },
      getCommittee() {
        this.$store.dispatch(GET_COMMITTEES)
          .then(response => {
            if (response.success) {
              this.committees = response.data;
            }
          });
      },
      getPublicationCat(){
        this.$store.dispatch(GET_ALL_PUBLICATION_CATEGORIES)
          .then(response => {
            if (response.success) {
              this.publication_categories = response.data;
            }
          });
      },
      updateCurrentReg(id){
        this.getUserRequest(id);
      },
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Outstanding Activities'] = routes.ADMIN.OUTSTANDING_ACTIVITIES;
        breadcrumbs['All Pending Registrations'] = routes.ADMIN.PENDING_REGISTRATION_ALL;
        breadcrumbs['Pending Approval'] = routes.ADMIN.PENDING_REGISTRATION+this.$route.params.id;
        breadcrumbs['Edit Registration'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      userSubscriptionChange(evt) {
        this.updatedSubscription = evt;
      },
      getUserRequest(id){
        this.$store.dispatch(GET_USER_REQUEST).then(resposne => {
          this.$store.dispatch('updateCurrentRegistration',id)
        });
      },
      resetStates(){
        this.states = constants.USER_STATES;
      },
      valueExistInObjArray(value, array) {
        return array.some(elem => elem.id === value)
      },
      getUsers(){
        this.$store.dispatch(GET_ALL_USERS)
      },
      getUser(id)
      {
        this.$store.dispatch('updateCurrentUser',id);
      },
      getUserInfo(id)
      {
        this.$store.dispatch(GET_USER_INFO,id);
      },
      containsObject(obj, list,isSite) {
        if(isSite){
          for(let i = 0;i<list.length;i++){
            if(obj.id === list[i].id){
              return true
            }
          }
        }else{
          for (let i = 0; i < list.length; i++) {
            if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
              return true;
            }
          }
        }
        return false;
      },
      checkInObj(obj, objArr,isSite,parent_id) {
        if (objArr.some(o => o.id === obj.id)) {
          objArr.splice(objArr.findIndex(o => o.id === obj.id), 1)
        } else {
          if(isSite === true){
            let temp = {};
            temp.id = obj.id;
            temp.value = obj.site_number+'-'+obj.name;
            objArr.push(temp)
          }else if(isSite === false && (obj.id === parent_id))
          {
            let temp = {};
            temp.id = obj.id;
            temp.value = obj.value;
            temp.children = [];
            objArr.push(temp)
          }
          else{
            let temp = {};
            temp.id = obj.id;
            temp.value = obj.value ? obj.value:obj.name;
            objArr.push(temp)
          }
        }
      },
      setFacilitySeq(index) {
        return parseInt(index) + 1;
      },
      delFacility(index) {
        //  del facility when user click 'x'
        if(this.form.facilities.length === 1){
          this.facilityError = 'At lease one Facility should be selected!';
        }else{
          this.facilityError = '';
          this.form.facilities.splice(index,1);
        }
      },
      checkDuplicateFacility(facility_number, index) {
        //  check if duplicate value exists.
        let checkDup = false;
        Object.values(this.form.facilities).forEach(function (value, key) {
          if (value.facility_number === facility_number && key !== index) {
            checkDup = true;
          }
        });
        return checkDup;
      },
      formatFacility(params) {
        let result = [];
        for (let key in params) {
          if(key === 'facility_number'){
            let title = 'Facility Accreditation Number';
            let obj = {
              'title': title,
              'desc': params[key]
            };
            result.push(obj);
          }else if(key === 'facility_name'){
            let title = 'Facility Name';
            let obj = {
              'title': title,
              'desc': params[key]
            };
            result.push(obj);
          }else if(key === 'sites'){
            var sites = '';
            for(let k in params[key])
            {
              sites += (params[key][k]['value']) + ','
            }
            let title = 'Site Number and Site Name';
            let obj = {
              'title': title,
              'desc': sites
            };
            result.push(obj);
          }
        }
        return result;
      },
      checkEditable(index,property){
        return (this.form.facilities[index][property].length > 0);
      },
      getFacility(value, index) {
        value = zeroPad(''+value, 6);
        this.form.facilities[index].facility_number = value;
        //  Get facility name if facility number is existed in DB;
        this.$store.dispatch(GET_FACILITY_INFO, value)
          .then(response => {
            if (response === undefined) {
              this.$notify({
                title: 'Error',
                text: 'Facility number is invalid.',
                type: 'error'
              });
              this.delFacility(index);
            }
            else if (this.checkDuplicateFacility(response.facility_number, index) === true) {
              this.$notify({
                title: 'Error',
                text: 'Duplicate facilities are not allowed.',
                type: 'error'
              });
              this.delFacility(index);
            }
            else {
              this.setFacility(response, index);
            }
          });
      },
      setFacility(data, index) {
        //  set facility name and make the input not editable
        this.form.facilities[index].facility_name = data.name;
        document.getElementById('facility '+index).value = data.name;
        this.form.facilities[index].allSites = data.sites;
      },
      addFacility() {
        //  add facility when user click '+'
        this.form.facilities.push(
          {
            "facility_number":'',
            "facility_name":'',
            "sites":[],
            "allSites":[],
          }
        );
      },
      formatCheckboxList(categories){
        let result = [];
        for(let category of categories){
          let cat = {};
          cat.id = category.id;
          cat.value = category.name;
          cat.items = [];
          if(category.children){
            for(let child of category.children){
              let subCat = {};
              subCat.id = child.id;
              subCat.value = child.name;
              subCat.selected = true;
              cat.items.push(subCat);
            }
          }
          result.push(cat)
        }
        return result;
      },
      formatSubscriptionListForCheckBox(list) {
        let res = [];
        let resEle = null;
        list.forEach(ele => {
          let resEleArr = res.filter(ele1 => ele1.id === ele.parent_id);
          if(resEleArr.length > 0) {
            resEle = resEleArr[0];
            }else {
            resEle = {
              'id':ele.parent_id, 'value':'root category',
              'items': []
            }
            res.push(resEle);
          }
          resEle.items.push(
              {'id':ele.id, 'value':ele.name}
            );
        });
        return res;
      },
    }
  }
</script>

